import React from 'react';

const TrustpillotIcon = (props) => (
  <svg {...props} viewBox='0 0 22 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M21.031 7.64341H13L10.5194 0L8.03101 7.64341L0 7.63566L6.50388 12.3643L4.0155 20L10.5194 15.2791L17.0155 20L14.5349 12.3643L21.031 7.64341Z'
      fill='#00B67A'
    />
    <path d='M15.0932 14.093L14.535 12.3643L10.5195 15.2791L15.0932 14.093Z' fill='#005128' />
  </svg>
);

export default TrustpillotIcon;
